module.exports = __webpack_public_path__ + "media/images/berry-virtual-67df17c1ac2681fc2c327651cf9b243a.png";